import { render, staticRenderFns } from "./translatable.component.vue?vue&type=template&id=1d6d8ef3&"
import script from "./translatable.component.vue?vue&type=script&lang=js&"
export * from "./translatable.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports